export default {
    "application/epub+zip": "epub",
    "application/java-archive": "jar",
    "application/javascript": "js",
    "application/json": "json",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "application/octet-stream": "exe",
    "application/oda": "oda",
    "application/ogg": "ogx",
    "application/pdf": "pdf",
    "application/postscript": "ps",
    "application/rtf": "rtf",
    "application/typescript": "ts",
    "application/vnd.amazon.ebook": "azw",
    "application/vnd.apple.installer+xml": "mpkg",
    "application/vnd.mozilla.xul+xml": "xul",
    "application/vnd.ms-excel": "xls",
    "application/vnd.ms-fontobject": "eot",
    "application/vnd.ms-powerpoint": "ppt",
    "application/vnd.oasis.opendocument.presentation": "odp",
    "application/vnd.oasis.opendocument.spreadsheet": "ods",
    "application/vnd.oasis.opendocument.text": "odt",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.visio": "vsd",
    "application/x-7z-compressed": "7z",
    "application/x-abiword": "abw",
    "application/x-bzip": "bz",
    "application/x-bzip2": "bz2",
    "application/x-cdf": "cdf",
    "application/x-csh": "csh",
    "application/x-dvi": "dvi",
    "application/x-gtar": "gtar",
    "application/x-hdf": "hdf",
    "application/x-latex": "latex",
    "application/x-mif": "mif",
    "application/x-netcdf": "nc",
    "application/x-pkcs12": "pfx",
    "application/x-pn-realaudio": "ram",
    "application/x-python-code": "pyc",
    "application/x-rar-compressed": "rar",
    "application/x-sh": "sh",
    "application/x-shar": "shar",
    "application/x-shockwave-flash": "swf",
    "application/x-tar": "tar",
    "application/x-tcl": "tcl",
    "application/x-tex": "tex",
    "application/x-texinfo": "texinfo",
    "application/x-troff": "roff",
    "application/x-troff-man": "man",
    "application/x-troff-me": "me",
    "application/x-troff-ms": "ms",
    "application/x-ustar": "ustar",
    "application/x-wais-source": "src",
    "application/xhtml+xml": "xhtml",
    "application/xml": "xml",
    "application/zip": "zip",
    "audio/3gpp": "3gp_DOES_NOT_CONTAIN_VIDEO",
    "audio/3gpp2": "3gp2_DOES_NOT_CONTAIN_VIDEO",
    "audio/aac": "aac",
    "audio/basic": "au",
    "audio/midi": "midi",
    "audio/mpeg": "mp3",
    "audio/ogg": "oga",
    "audio/webm": "weba",
    "audio/x-aiff": "aif",
    "audio/x-pn-realaudio": "ra",
    "audio/x-wav": "wav",
    "font/otf": "otf",
    "font/ttf": "ttf",
    "font/woff": "woff",
    "font/woff2": "woff2",
    "image/gif": "gif",
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/svg+xml": "svg",
    "image/tiff": "tif",
    "image/webp": "webp",
    "image/x-cmu-raster": "ras",
    "image/x-icon": "ico",
    "image/x-ms-bmp": "bmp",
    "image/x-portable-anymap": "pnm",
    "image/x-portable-bitmap": "pbm",
    "image/x-portable-graymap": "pgm",
    "image/x-portable-pixmap": "ppm",
    "image/x-rgb": "rgb",
    "image/x-xbitmap": "xbm",
    "image/x-xpixmap": "xpm",
    "image/x-xwindowdump": "xwd",
    "text/calendar": "ics",
    "text/css": "css",
    "text/csv": "csv",
    "text/html": "html",
    "text/plain": "txt",
    "text/richtext": "rtx",
    "text/tab-separated-values": "tsv",
    "text/x-python": "py",
    "text/x-setext": "etx",
    "text/x-sgml": "sgml",
    "text/x-vcard": "vcf",
    "video/3gpp": "3gp",
    "video/3gpp2": "3gp2",
    "video/mp4": "mp4",
    "video/mpeg": "mpeg",
    "video/ogg": "ogv",
    "video/quicktime": "mov",
    "video/webm": "webm",
    "video/x-msvideo": "avi",
    "video/x-sgi-movie": "movie",
};
